module.exports = "<p>\r\n    Your query did not return any results. Please refine your search parameters and try again.\r\n</p>\r\n"